<template>
  <div class="player-main">
    <div class="player-box">
      <div id="video_player"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      player: "",
      url: "https://huixuexi.multimediapress.cn//images/1/2023/03/28/b8736c6e-127a-4e09-a438-6f7a71a6410e.mp4?auth_key=1681716196-0-0-e27e3860873302170aab02d2edf1792c",
    };
  },
  methods: {
    DmsPlayers(playType, appId, vid, courseCover, time) {
      var that = this;
      this.player = new DmsPlayer({
        containerId: "video_player",
        url: vid,
        cover: courseCover,
        currentTime: time,
        autoplay: false, // 是否自动播放
        loop: false, // 是否循环播放
        showBar: true, //是否显示控制条
        autoHideBar: true, // 是否自动隐藏控制条
        autoHideBarTime: 5000, // 自动隐藏控制条时间
        playType: playType, // 播放方式 1地址播放（开放不加密）3防盗链播放（通过视频编号获取视频播放地址，防盗）
        appId: appId, // 获取防盗链项目id参数
        vid: vid, // 视频编号
        playCallBackTime: 1000, // 播放多长时间回调一次 单位毫秒
        playCallBack: function (data) {
          // 播放回调函数，在这里自定义调用播放过程中请求接口逻辑 data返回当前视频播放的时间,以及总时长
          let list = {
            name: "videoPlay",
            video: data,
          };
          that.$emit("reciveMessage", list);
        },
        onEnd: function (data) {
          // 当视频播放完的触发的自定义回调方法
          let list = {
            name: "videoEnd",
            video: data,
          };
          that.$emit("videoEnd", list);
        },
        onPause: function (data) {
          // 当视频播放暂停时触发的自定义回调方法
          let list = {
            name: "videoPause",
            video: data,
          };
          that.$emit("videoPause", list);
        },
        onError: function (data) {
          // 当视频播放出错时触发的自定义回调方法
          console.log("视频播放出错", data);
        },
        onDestroy: function(value) {
          console.log("调用了销毁", value);
            }
      });
    },
    destroy() {
      if(this.player){
        this.player.destroy();
      }
    },
    CurrentTime(e) {
      this.player.changeCurrentTime(e);
    },
  },
};
</script>
<style scoped lang="scss">
.player-main {
  /* width: 960px; */
  max-width: 100%;
  margin: 0 auto;
}

.player-main .player-box {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}

.player-main #video_player {
  position: absolute;
  width: 100%;
  height: 100%;
}
.dp-controls .dp-right-controls .dp-btn-speed {
  display: block !important;
}
</style>
